export const DEMO_SEED_INTENT_KEY = "demo:seed-after-create";
